import { useEffect } from 'react';

import { EMPTY_TREE_REPLACEMENT_FORM, toCreateInput } from './tree-replacement-form';
import { TreeReplacementForm } from './TreeReplacementForm';
import { useCreateTreeReplacement } from './use-tree-replacements';

export function AddTreeReplacementContent({
  workshopId,
  formId,
  onSavingChange,
  onDone,
}: {
  workshopId: string;
  formId: string;
  onSavingChange: (saving: boolean) => void;
  onDone: () => void;
}) {
  const create = useCreateTreeReplacement(workshopId);
  useEffect(() => onSavingChange(create.isPending), [create.isPending, onSavingChange]);
  return (
    <TreeReplacementForm
      formId={formId}
      initial={EMPTY_TREE_REPLACEMENT_FORM}
      saving={create.isPending}
      error={create.error}
      onSubmit={(values) => create.mutate(toCreateInput(values), { onSuccess: onDone })}
    />
  );
}
